import { render, staticRenderFns } from "./SidebarAddons.vue?vue&type=template&id=7e8b0a76&lang=pug&"
import script from "./SidebarAddons.vue?vue&type=script&lang=js&"
export * from "./SidebarAddons.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddons.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports